import { type ReactNode } from "react";
import { AuthContext } from "./AuthContext";
import { useAuthState, type UseAuthStateOptions } from "./use-auth-state";

export interface AuthProviderProps {
  children: ReactNode;
  options?: UseAuthStateOptions;
}

export const AuthProvider = ({ children, options }: AuthProviderProps) => {
  const auth = useAuthState(options);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
